module.exports = __webpack_public_path__ + "static/media/HealthBanner.e63a762c.svg";